import React, { Fragment } from "react";
import { SaveButton, DeleteButton, EditButton, ShowButton, Datagrid, useUnselectAll, useResourceContext, useListContext } from "react-admin";

import { generateField } from "../factory";
import ExpandGrid from "./ExpandGrid";
import MoveButton from "./MoveButton";

import {
  useMediaQuery,
  Divider,
  Tabs,
  Tab,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const Total = styled('span')({
  fontWeight: 'bold',
});

class TabedGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    try {
      JSON.parse(props.resourcePermistions.list_tabs).forEach(a => {
        this.state[String(a.id)] = [];
      });
    } catch (error) {
      console.error("Error parsing list_tabs in constructor:", error);
    }
  }

  static getDerivedStateFromProps(props, state) {
    const currentId = String(props.filterValues[props.resourcePermistions.list_tab_filter]);
    if (JSON.stringify(props.ids) !== JSON.stringify(state[currentId])) {
      return { ...state, [currentId]: props.ids };
    }
    return null;
  }

  handleChange = (event, value) => {
    const { filterValues, setFilters, resourcePermistions, unselectAll, resource } = this.props;
    unselectAll(resource);
    setFilters({ ...filterValues, [resourcePermistions.list_tab_filter]: value });
  };

  componentDidUpdate(prevProps) {
    const { filterValues, resourcePermistions, onTabChange } = this.props;
    
    // Only trigger onTabChange when the filter actually changes
    if (prevProps.filterValues[resourcePermistions.list_tab_filter] !== filterValues[resourcePermistions.list_tab_filter]) {
      let uiTabsConfig = {};
      if (resourcePermistions.list_tabs) {
        try {
          uiTabsConfig = JSON.parse(resourcePermistions.list_tabs);
        } catch (error) {
          console.error("Error parsing tabs settings:", error);
          return;
        }
      }
      
      uiTabsConfig.forEach(choice => {
        if (String(filterValues[resourcePermistions.list_tab_filter]) === String(choice.id)) {
          if (typeof onTabChange !== 'undefined') {
            onTabChange(choice.key, choice.value);
          }
        }
      });
    }
  }

  render() {
    const { 
      isXSmall, 
      filterValues, 
      resourcesFields, 
      resourcePermistions, 
      onTabChange, 
      unselectAll, 
      resource,
      displayedFilters,
      setFilters,
      hideFilter,
      ...props 
    } = this.props;
    const role = localStorage.getItem('role');
    let uiTabsConfig = {};

    if (resourcePermistions.list_tabs) {
      try {
        uiTabsConfig = JSON.parse(resourcePermistions.list_tabs);
      } catch (error) {
        console.error("Error parsing tabs settings:", error);
      }
    }

    let moveEnabled = false;
    let moveKey = "position";

    if (resourcePermistions && resourcePermistions.init_values) {
      try {
        const extraConfig = JSON.parse(resourcePermistions.init_values);
        if (extraConfig.moveEnabled) {
          moveEnabled = extraConfig.moveEnabled;
        }
        if (extraConfig.moveKey) {
          moveKey = extraConfig.moveKey;
        }
      } catch (error) {
        console.error("Error parsing move settings:", error);
      }
    }

    return (
      <Fragment>
        <Tabs
          variant="fullWidth"
          centered
          value={String(filterValues[resourcePermistions.list_tab_filter])}
          indicatorColor="primary"
          onChange={this.handleChange}
        >
          {uiTabsConfig.map(choice => (
            <Tab
              key={choice.id}
              label={choice.name}
              value={String(choice.id)}
            />
          ))}
        </Tabs>
        <Divider />

        <div>
          {uiTabsConfig.map(choice => {
            if (String(filterValues[resourcePermistions.list_tab_filter]) === String(choice.id)) {
              return (
                <Datagrid
                  key={choice.id}
                  {...props}
                  rowClick={false}
                  ids={this.state[String(choice.id)]}
                  expand={resourcePermistions.is_expand ? <ExpandGrid linkedResourcePermistions={resourcePermistions} /> : null}
                >
                  {resourcesFields.map((f, index) => {
                    // Create unique key using source_name + index
                    const uniqueKey = `field-${index}-${f.source_name || index}`;
                    return generateField(f, uniqueKey, null, 'list-view', props.id);
                  })}
                  {resourcePermistions && resourcePermistions[`${role}_edit`] === true && choice.allowEdit === true && <EditButton key="edit-btn" />}
                  {resourcePermistions && resourcePermistions[`${role}_delete`] === true && choice.allowDelete === true && <DeleteButton key="delete-btn" />}
                  {resourcePermistions && resourcePermistions[`${role}_show`] === true && choice.allowShow === true && <ShowButton key="show-btn" />}

                  {moveEnabled && (
                    <Fragment key="move-buttons">
                      <MoveButton key="move-up" direction="up" />
                      <MoveButton key="move-down" direction="down" />
                    </Fragment>
                  )}

                </Datagrid>
              );
            }
            return null;
          })}
        </div>
      </Fragment>
    );
  }
}

const TabedListGrid = (props) => {
  const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
  const resource = useResourceContext();
  const unselectAll = useUnselectAll(resource);
  const { displayedFilters, filterValues, setFilters, hideFilter } = useListContext();

  return <TabedGrid {...props} filterValues={filterValues} displayedFilters={displayedFilters} setFilters={setFilters} hideFilter={hideFilter} resource={resource} unselectAll={unselectAll} />;
};

export default TabedListGrid;
